let publicPath = "/";
// 로컬 개발 - 개발 서버
if(process.env.NODE_ENV === 'local') {
    // 로컬
    publicPath ='/assets/gncitizen/';
} else if(process.env.NODE_ENV === 'development') {
    // 개발
    publicPath ='/gncitizen/assets/gncitizen/';
} else if(process.env.NODE_ENV === 'production') {
    // 운영
    publicPath ='/assets/gncitizen/';
}

export const defualtMeta = [
    {
        vmid: 'description',
        name: 'description',
        content:
            '꿈이 모이는 도시, 미래를 그리는 강남',
    },
    {
        vmid: 'og:description',
        property: 'og:description',
        content: '꿈이 모이는 도시, 미래를 그리는 강남',
    },
    {
        vmid: 'og:site_name',
        property: 'og:site_name',
        content: '데이터 강남 플랫폼',
    },
    {
        vmid: 'og:title',
        property: 'og:title',
        content: '데이터 강남 플랫폼',
    },
    {
        vmid: 'og:type',
        property: 'og:type',
        content: 'website',
    },
    {
        vmid: 'og:url',
        property: 'og:url',
        content: window.location.href,
    },
    {
        vmid: 'og:image',
        property: 'og:image',
        content: publicPath + 'img/id_system.png',
    },
];
// console.log(window.location);
